import {Component, property, Type} from '@wonderlandengine/api';

export class Tags extends Component {
    static TypeName = 'tags';

    @property.string('')
    tags = '';

    /**
     *
     * @param {string} tag the tag to test
     */
    hasTag(tag) {
        const tags = this.tags.split(/\W+/g);
        return !!~tags.indexOf(tag);
    }
}
